import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useGlobalContext } from "../../../context.js";
import { SocialIcons } from "@/components/common/SocialIcons";
import { wavingHand, overlayImage } from "@/images";
import { Button } from "@/components/ui";
import { LayoutContainer } from "@/components/common/LayoutContainer";

export const Overlay = () => {
  const { t } = useGlobalContext();
  const { i18n } = useTranslation();

  const isAr = i18n.language === "ar";




  return (
    <LayoutContainer className="min-h-[83vh]">
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-1 flex-col md:flex-row items-center py-12  overflow-hidden justify-around"
      >
        <div className="container flex flex-col items-start text-left h-[100%]  align-middle justify-center">
          <SocialIcons />
          <div className="">
            <div className="flex items-center gap-2">
              <img className="w-10" src={wavingHand} alt="waving hand" />
              <h3 className="text-4xl font-semibold">{t("overlay.hey")}</h3>
            </div>
            <h2 className="text-4xl leading-10 font-extrabold lg:text-6xl mt-8">
              {t("overlay.title")}
            </h2>
          </div>
            <p className="text-[1.3em] leading-9 mt-6 max-w-lg text-gray-700 dark:text-gray-300 ">
            {t("overlay.description")}
            </p>
          <Link to="/contact">
            <Button
              variant="secondary"
              className="gap-2 mt-6"
            >
              {t("overlay.btn")} {isAr ? <ArrowLeft /> : <ArrowRight />}
            </Button>
          </Link>
        </div>
        <blockquote className="mt-6 border-l-2 pl-6 text-2xl italic text-gray-700 dark:text-gray-300 hidden md:block">
          "Technology is best when it brings people together."
          <br />
          <span className="text-right block mt-4 text-2xl font-bold">
            — Matt Mullenweg
          </span>
        </blockquote>
      </motion.section>
    </LayoutContainer>
  );
};
